exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row[_v-396ad93e]{margin:20px 0 0 20px}.btn-blue[_v-396ad93e],.btn-blue[_v-396ad93e]:focus,.btn-blue[_v-396ad93e]:hover{border:none;border-radius:0;margin:10px;padding:10px 40px;color:#fff;font-family:Open Sans;font-size:12px;font-weight:700}.btn-blue[_v-396ad93e]:focus,.btn-blue[_v-396ad93e]:hover{background-color:#4ab6e2}@media (max-width:970px){.btn-blue[_v-396ad93e],.btn-blue[_v-396ad93e]:focus,.btn-blue[_v-396ad93e]:hover{padding:10px 20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-396ad93e&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Admin/Admin-projects-navbar.vue
// module id = 421
// module chunks = 0